// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isDialog .accordionDIV {
    max-height: 42vh;
    display: flex;
    flex-direction: column;
}

.selectAllCB {
    font-weight: bold;
    margin: 0px 0px 7px 4px;
}

.colCB {
    margin: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/requestoptions/request.options.control.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".isDialog .accordionDIV {\n    max-height: 42vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.selectAllCB {\n    font-weight: bold;\n    margin: 0px 0px 7px 4px;\n}\n\n.colCB {\n    margin: 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
